import getStore from '../store/appHostStore';
import type AppHostViewState from '../store/schema/AppHostViewState';

export default (viewState: AppHostViewState): boolean => {
    return getStore().viewStates.get(viewState.appHostId)?.isInError || false;
};
